/* =====================================================
   DAR_CUSTOM: DarBeauty Custom JavaScript
   هذا الملف يحتوي جميع السكربتات المخصصة لـ DarBeauty
   عند تحديث الثيم: انسخ هذا الملف كاملاً بدون تعديل
   ===================================================== */
document.addEventListener('DOMContentLoaded', function () {
  /* ===== تنظيف روابط المنتجات من معلمات البحث ===== */
  if (window.location.pathname.includes('/products/')) {
    // التحقق مما إذا كان الرابط الحالي يحتوي على معلمات بحث
    if (window.location.search) {
      // إنشاء URLSearchParams للتعامل مع معلمات البحث
      var urlParams = new URLSearchParams(window.location.search);

      // التحقق من وجود ref=review
      var hasRefReview = urlParams.get('ref') === 'review';

      var cleanUrl;
      if (hasRefReview) {
        // الاحتفاظ فقط بـ ref=review
        cleanUrl = window.location.origin + window.location.pathname + '?ref=review';
      } else {
        // إنشاء الرابط النظيف (بدون معلمات البحث)
        cleanUrl = window.location.origin + window.location.pathname;
      }

      // استخدام history.replaceState لتغيير URL دون إعادة تحميل الصفحة
      history.replaceState({}, document.title, cleanUrl);
    }
  }

  /* ===== فتح الكيبورد عند الضغط على زر البحث ===== */
  var searchLink = document.querySelector('a[href="/search"]');
  var searchInput = document.querySelector('header-search .header-search__input');
  var searchDialog = document.querySelector('header-search[role="dialog"]');
  if (searchLink && searchInput && searchDialog) {
    searchLink.addEventListener('touchend', function (event) {
      event.preventDefault();
      if (!searchDialog.hasAttribute('open')) {
        searchDialog.setAttribute('open', '');
        searchDialog.style.display = 'block';
        // تجنب استدعاء offsetHeight للحد من إعادة التدفق
        setTimeout(function () {
          searchInput.focus();
        }, 10);
      } else {
        searchInput.focus();
      }
    });
  }

  /* ===== إخفاء زر "نفذ من المخزون" عندما يكون المنتج غير متوفر ===== */
  var soldOutButton = document.querySelector('.shopify-product-form .button[disabled]');
  if (soldOutButton) {
    soldOutButton.style.display = 'none';
  }

  /* ===== Footer responsive (updateFooterBlocks on resize/load) ===== */
  var _ftResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_ftResizeTimer);
    _ftResizeTimer = setTimeout(function () { updateFooterBlocks(); }, 100);
  });
  setTimeout(function () { updateFooterBlocks(); }, 0);

  /* ===== DAR_CUSTOM: زر الإضافة السريعة (+) ===== */

  function darIsArabic() {
    return (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
  }

  function darCartErrorText() {
    return darIsArabic()
      ? 'تعذّر إضافة المنتج إلى السلة. الرجاء المحاولة مرة أخرى.'
      : 'Could not add the product to your cart. Please try again.';
  }

  function darShowCartError(message) {
    var host = document.getElementById('dar-cart-error');
    if (!host) {
      host = document.createElement('div');
      host.id = 'dar-cart-error';
      document.body.appendChild(host);
    }
    host.innerHTML = '';
    var banner = document.createElement('div');
    banner.className = 'banner banner--error';
    banner.setAttribute('role', 'alert');
    banner.setAttribute('aria-live', 'polite');
    banner.textContent = message;
    host.appendChild(banner);
    clearTimeout(host.darTimer);
    host.darTimer = setTimeout(function () { host.innerHTML = ''; }, 5000);
  }

  function darClearCartError() {
    var host = document.getElementById('dar-cart-error');
    if (!host) return;
    clearTimeout(host.darTimer);
    host.innerHTML = '';
  }

  function darButtonOfEvent(e) {
    var form = e.target && e.target.closest ? e.target.closest('form') : null;
    if (!form) return null;
    return form.querySelector('.product-card__quick-add-button');
  }

  document.addEventListener('variant:add', function (e) {
    var btn = darButtonOfEvent(e);
    darClearCartError();
    if (btn && document.activeElement === btn) {
      try { btn.blur(); } catch (err) {}
    }
  }, true);

  document.addEventListener('cart:error', function (e) {
    var btn = darButtonOfEvent(e);
    if (!btn) return;
    if (document.activeElement === btn) {
      try { btn.blur(); } catch (err) {}
    }
    darShowCartError((e.detail && e.detail.error) || darCartErrorText());
  }, true);

  /* ===== DAR_CUSTOM: زر إتمام الشراء في درج السلة — حالة التحميل =====
     الزر submit داخل form يُحوِّل تحويلاً أصلياً، فيبدو جامداً حتى يبدأ التحويل
     (محسوس خاصة في الجوال). نضيف كلاساً للتعتيم وإظهار دائرة تحميل ومنع الضغط
     المتكرر. لا نستخدم disabled لأنه يُلغي إرسال النموذج ويمنع الدفع فعلياً. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    if (btn.classList.contains('dar-is-submitting')) return;

    btn.classList.add('dar-is-submitting');

    // شبكة أمان: إذا لم يبدأ التحويل (انقطاع شبكة أو إلغاء) أعد الزر لحالته
    setTimeout(function () { btn.classList.remove('dar-is-submitting'); }, 12000);
  }, true);

  // عند الرجوع من صفحة الدفع (زر الرجوع / bfcache) أعد الزر لحالته الطبيعية
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('button[name="checkout"].dar-is-submitting').forEach(function (b) {
      b.classList.remove('dar-is-submitting');
    });
  });
  /* ===== قوائم الفوتر القابلة للطي لأجهزة الجوال ===== */
  var footerBlocksProcessed = false;

  function updateFooterBlocks() {
    var isMobile = window.innerWidth <= 699;
    var footerBlocks = document.querySelectorAll('.footer__block');

    // تنفيذ التحويل فقط إذا كان الوضع مختلفًا عن الحالة السابقة
    if (isMobile && !footerBlocksProcessed) {
      footerBlocks.forEach(function (block) {
        var title = block.querySelector('.h6');
        if (title) {
          // تخزين المحتوى الأصلي لاستخدامه لاحقًا عند الحاجة
          if (!block.dataset.originalContent) {
            block.dataset.originalContent = block.innerHTML;
          }

          var content = title.nextElementSibling;
          var accordionDisclosure = document.createElement('accordion-disclosure');
          var details = document.createElement('details');
          var summary = document.createElement('summary');
          summary.innerHTML = title.textContent + '<span class="animated-plus"></span>';
          details.appendChild(summary);
          if (content) {
            details.appendChild(content.cloneNode(true));
          }
          accordionDisclosure.appendChild(details);

          // استخدام replaceChildren بدلاً من innerHTML للأداء الأفضل
          while (block.firstChild) {
            block.removeChild(block.firstChild);
          }
          block.appendChild(accordionDisclosure);
        }
      });
      footerBlocksProcessed = true;
    } else if (!isMobile && footerBlocksProcessed) {
      // إعادة المحتوى الأصلي عند العودة إلى وضع سطح المكتب
      footerBlocks.forEach(function (block) {
        if (block.dataset.originalContent) {
          block.innerHTML = block.dataset.originalContent;
        }
      });
      footerBlocksProcessed = false;
    }
  }
  /* ===== مغير اللغة والبلد الموحد ===== */
  (function () {
    var popup = document.getElementById('dar-locale-popup');
    if (!popup) return;

    var langToggle = document.getElementById('dar-lang-toggle');
    var countryList = document.getElementById('dar-country-list');
    var formLocale = document.getElementById('dar-form-locale');
    var formCountry = document.getElementById('dar-form-country');
    var applyBtn = document.getElementById('dar-locale-apply');
    var form = applyBtn ? applyBtn.closest('form') : null;
    var returnToInput = form ? form.querySelector('input[name="return_to"]') : null;

    // القيم الفعلية المؤكدة من السيرفر (مصدر الحقيقة)
    // الحقول المخفية تتغيّر بنقرات المستخدم، لذلك لا نعتمد عليها كمرجع
    var currentLang = popup.dataset.currentLocale || (formLocale ? formLocale.value : '');
    var currentCountry = popup.dataset.currentCountry || (formCountry ? formCountry.value : '');

    // القيم الأصلية عند فتح الـ popup (تُحدَّث عند كل فتح)
    var initialLang = currentLang;
    var initialCountry = currentCountry;

    // تحديث حالة زر التطبيق
    function updateApplyState() {
      if (!applyBtn || !formLocale || !formCountry) return;
      var hasChanged = formLocale.value !== initialLang
                    || formCountry.value !== initialCountry;
      applyBtn.disabled = !hasChanged;
      applyBtn.classList.toggle('is-disabled', !hasChanged);
    }

    function buildCheckSvg() {
      var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      checkSvg.setAttribute('class', 'dar-country-list__check');
      checkSvg.setAttribute('width', '14');
      checkSvg.setAttribute('height', '14');
      checkSvg.setAttribute('viewBox', '0 0 16 16');
      checkSvg.setAttribute('fill', 'none');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M3 8.5L6.5 12L13 4');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      checkSvg.appendChild(path);
      return checkSvg;
    }

    // تحديد اللغة بصرياً وفي الحقل المخفي
    function selectLanguage(code) {
      if (!langToggle || !formLocale) return;
      langToggle.querySelectorAll('.dar-lang-toggle__btn').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.langCode === code);
      });
      formLocale.value = code;
    }

    // تحديد البلد بصرياً وفي الحقل المخفي
    function selectCountry(code) {
      if (!countryList || !formCountry) return;
      formCountry.value = code;
      countryList.querySelectorAll('.dar-country-list__item').forEach(function (item) {
        var isSelected = item.dataset.countryCode === code;
        item.classList.toggle('is-selected', isSelected);
        var check = item.querySelector('.dar-country-list__check');
        if (isSelected && !check) {
          item.appendChild(buildCheckSvg());
        } else if (!isSelected && check) {
          check.remove();
        }
      });
    }

    // إعادة الـ popup لحالته الأصلية المطابقة للغة/بلد الموقع الفعلي
    function resetPopupState() {
      selectLanguage(currentLang);
      selectCountry(currentCountry);
      initialLang = currentLang;
      initialCountry = currentCountry;

      // مزامنة return_to مع الصفحة الحالية وقت الفتح
      if (returnToInput) {
        returnToInput.value = window.location.pathname + window.location.search;
      }

      // إعادة زر التطبيق لحالته الطبيعية (مهم عند استرجاع الصفحة من bfcache أثناء التحميل)
      if (applyBtn) {
        var textEl = applyBtn.querySelector('.dar-locale-popup__apply-text');
        var loaderEl = applyBtn.querySelector('.dar-locale-popup__apply-loader');
        if (textEl) textEl.style.display = '';
        if (loaderEl) loaderEl.hidden = true;
      }
      updateApplyState();
    }

    // مزامنة اللغة مع الحقل المخفي (أزرار أفقية)
    if (langToggle) {
      langToggle.addEventListener('click', function (e) {
        var btn = e.target.closest('.dar-lang-toggle__btn');
        if (!btn || btn.classList.contains('is-active')) return;
        selectLanguage(btn.dataset.langCode);
        updateApplyState();
      });
    }

    // معالجة اختيار البلد من القائمة (buttons with flags)
    if (countryList) {
      countryList.addEventListener('click', function (e) {
        var btn = e.target.closest('.dar-country-list__item');
        if (!btn || !btn.dataset.countryCode) return;
        selectCountry(btn.dataset.countryCode);
        updateApplyState();
      });
    }

    // فتح الـ popup
    document.querySelectorAll('[data-open-locale-popup]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // إعادة التعيين عند كل فتح — يمنع بقاء اختيارات غير مطبَّقة من مرة سابقة
        resetPopupState();

        // إذا كان الزر داخل السايدبار → أغلق السايدبار أولاً
        var sidebar = trigger.closest('header-sidebar');
        if (sidebar) {
          sidebar.removeAttribute('open');
          setTimeout(function () { popup.showModal(); }, 350);
        } else {
          popup.showModal();
        }
      });
    });

    // إغلاق الـ popup
    popup.querySelectorAll('[data-close-popup]').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.close();
      });
    });

    // منع إغلاق عند الضغط على المحتوى
    var panel = popup.querySelector('.dar-locale-popup__panel');
    if (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // عند استرجاع الصفحة من bfcache (بعد خمول طويل أو زر الرجوع):
    // أغلق الـ popup وأعد تهيئته حتى لا يبقى الزر معطلاً أو الحقول بلغة قديمة
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        if (popup.open) popup.close();
        resetPopupState();
      }
    });

    // حالة التحميل عند الإرسال
    if (applyBtn && form) {
      form.addEventListener('submit', function () {
        applyBtn.disabled = true;
        var textEl = applyBtn.querySelector('.dar-locale-popup__apply-text');
        var loaderEl = applyBtn.querySelector('.dar-locale-popup__apply-loader');
        if (textEl) textEl.style.display = 'none';
        if (loaderEl) loaderEl.hidden = false;
      });
    }
  })();
});